// extracted by mini-css-extract-plugin
export default {"button":"ButtonLike_button__Wegl8","button--liked":"ButtonLike_button--liked__XMBD0","button--loading":"ButtonLike_button--loading__yKVVY"};